// dialog.service.ts
import { Injectable } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { TimeoutModalComponent } from 'mds-ui/app/core/timeout-modal/timeout-modal.component';

@Injectable({ providedIn: 'root' })
export class DialogService {
  constructor(private dialog: MatDialog) {}

  openDialog(title: string, message: string): void {
    this.dialog.open(TimeoutModalComponent, {
      data: { title, message },
      width: '500px',
      panelClass: 'dark-dialog'
    });
  }
}
